"use client"

import { useEffect } from "react"
import { useRouter } from "next/navigation"

export default function RefreshOnFocus() {
  const router = useRouter()

  useEffect(() => {
    // fire once whenever the page becomes the foreground tab
    console.debug("REFRESH")
    const refresh = () => router.refresh()

    // 1. most browsers
    window.addEventListener("focus", refresh)
    // 2. fallback for browsers that only emit visibilitychange
    document.addEventListener("visibilitychange", () => {
      if (!document.hidden) refresh()
    })

    return () => {
      window.removeEventListener("focus", refresh)
      document.removeEventListener("visibilitychange", refresh)
    }
  }, [router])

  return null // nothing to render
}
